import { Component, OnInit } from '@angular/core';
import { BookingService } from '../../../../core/services/booking.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MustMatch } from './../_helpers/must-match.validator';
import { PatentValidator } from './../_helpers/patent.validator';
import { Location } from '@angular/common';
import { RecaptchaService } from 'src/app/core/services/recaptcha.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.scss']
})
export class PersonalInformationComponent implements OnInit {
  public license: string = '';
  public typeVehicle = 'Tipo de vehículo';
  public contactName: string = '';
  public phone: string = '';
  public email: string = '';
  public email2: string = '';
  public date: string;
  public plant: string;
  public hour: string;
  public address: string;
  registerForm: FormGroup;
  public reference: string;
  submitted = false;
  public reagendarPatente: string;
  public codePlant: string;
  public arrayType = []; // Contains the aaa types
  public selectText = [];
  public codeType: string;
  closeResult: string;
  public myMaps: boolean = false;
  public myRecaptcha: boolean = false;
  public myProcesoRecaptcha: boolean = false;
  // public compose(validators: ValidatorFn[]) : ValidatorFn;
  // static compose(validators: ValidatorFn[]): ValidatorFn;

  constructor(
    private formBuilder: FormBuilder,
    private bookingService: BookingService,
    private route: Router,
    private modalService: NgbModal,
    private location: Location,
    private _recaptchaService: RecaptchaService,  
    private recaptchaV3Service: ReCaptchaV3Service
  ) { }

  ngOnInit() {
    this.getVehicleTypes();
    this.verifyBookingOperation();
    this.getPrebookingData();
  }

  /* Gets the available vehicle types */
  getVehicleTypes() {
    this.bookingService.getVehicleTypes().subscribe(
      response => {
        if (response.status === true) {
          this.arrayType = response.message;
        }
      }
    );
  }

  /* Creates a form whether it is a plant/date booking or a re-booking */
  verifyBookingOperation() {
    this.bookingService.getDataChangeBooking().subscribe((response) => {
      /* If its NOT a rebook operation */
      if (response.patent === undefined) {
        this.registerForm = this.formBuilder.group({
          patent: ['', Validators.required],
          vehicle: ['', Validators.required],
          contact: ['', [Validators.required, Validators.minLength(5)]],
          telephone: ['', [Validators.required, Validators.minLength(9)]],
          email: ['', [Validators.required, Validators.email]],
          emailConfirm: ['', Validators.required],
          checkBoxConfirm: [false, Validators.required],
          checkBoxFutureNotification: [true]
        },
          {
            validator: [MustMatch('email', 'emailConfirm'), PatentValidator('patent')]
          });
      } else {
        /* If ITS a rebook operation */
        this.registerForm = this.formBuilder.group({
          patent: [''],
          vehicle: [{ value: '', disabled: true }],
          contact: ['', [Validators.required, Validators.minLength(5)]],
          telephone: ['', [Validators.required, Validators.minLength(9)]],
          email: ['', [Validators.required, Validators.email]],
          emailConfirm: ['', Validators.required],
          checkBoxConfirm: [false, Validators.required],
          checkBoxFutureNotification: [true]
        },
          {
            validator: [MustMatch('email', 'emailConfirm')]
          });
        this.registerForm.patchValue({
          vehicle: response.type,
          contact: response.name,
          telephone: response.phone,
          email: response.email,
          emailConfirm: response.email
        });
        this.registerForm.updateValueAndValidity();
        this.reagendarPatente = response.patent;
        this.setPatentValue();
      }
    });
  }

  /* Gets the prebooking data from a plant (from select-plant and select-datetime) */
  getPrebookingData() {
    this.bookingService.getPlantPrebookingData().subscribe(
      (response) => {
        this.date = this.convertStringToFomart(response.date);
        if (this.date === undefined) {
          this.route.navigateByUrl('/');
        } else {
          this.reference = response.reference;
          this.plant = response.plant;
          this.hour = moment(response.hour, ['H:mm']).format('h:mm A');
          this.address = response.address;
          this.codePlant = response.code_plant;
        }
      }
    );
  }

  get f() { return this.registerForm.controls; }

  /* On submit personal data */
  onSubmit() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      Object.keys(this.registerForm.controls).forEach(key => {
        this.registerForm.get(key).markAsDirty();
      });
      return;
    }
    if (this.registerForm.valid) {
      if (this.reagendarPatente === undefined) {
        /* If its NOT a rebook */
        gtag('event', 'Reserva6', {'event_category': 'Reserva6', 'event_label': 'Reserva6', 'value': 'Reserva6'});
        this.bookingService.saveBooking(
          this.quitarFormato(this.registerForm.value.patent),
          this.registerForm.value.contact,
          this.registerForm.value.telephone,
          this.registerForm.value.email,
          this.registerForm.value.vehicle,
          //"1.00",
          this.selectText[0].technical_prt_price,
          1,
          this.registerForm.value.checkBoxFutureNotification
        ).subscribe(
          response => {
            if (response.status === 'AMACL-796') {
              this.myMaps = true;
            } else if (response.status) {
              this.myMaps = false;
              this.bookingService.setReservationCode(response.message.reservation_code);
              this.sendEmail();
            }
          }
        );
      } else {

        /* if ITS a rebook */
        this.bookingService.changeBooking(
          this.reagendarPatente,
          this.registerForm.value.contact,
          this.registerForm.value.telephone,
          this.registerForm.value.email,
          this.registerForm.value.vehicle,
          0,
          0
        ).subscribe(
          response => {
            if (response.status) {
              this.sendEmail(true);
            }
          }
        );
      }
    }
  }

  sendEmail(rebook: boolean = false) {
    this.bookingService.sendMail().subscribe(
      res => {
        let url = '/booking/booking-confirmed';
        if(rebook) url += '?rebook=true';
        if (res.status) { this.route.navigateByUrl(url); }
      }
    );
  }

  convertStringToFomart(dt, format = 'DD MMMM YYYY') {
    moment.locale('es-es');
    return moment.utc(dt).format(format);
  }

  onChangeVehicleType($event) {
    this.selectText = this.arrayType.filter(
      array => array.technical_review_type === this.registerForm.value.vehicle
    );
  }

  /* Opens the privacy policies modal */
  openPrivacyPolicies(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  setPatentValue() {
    const elem: HTMLInputElement = <HTMLInputElement>document.getElementById('patentes');
    const value: string = this.format(this.reagendarPatente);
    elem.value = value;
  }

  format(value) {
    if (value) {
      value = value.toUpperCase();
      value = this.quitarFormato(value);
      value = value.substring(0, 6);
      if (value.length === 5) {
        if (this.isMotoOld(value)) {
          value = [value.slice(0, 2), '-', value.slice(2)].join('');
        } else if (this.isMotoNew(value)) {
          value = [value.slice(0, 3), '-', value.slice(3)].join('');
        }
      } else if (value.length === 6) {
        if (this.esAntigua(value)) {
          value = [value.slice(0, 2), '-', value.slice(2)].join('');
        } else if (this.esNueva(value)) {
          value = [value.slice(0, 4), '-', value.slice(4)].join('');
        }
      }
      return value;
    }
  }

  quitarFormato(patente) {
    return patente.replace(/\W+/g, '').toUpperCase();
  }

  navigatorBack() {
    gtag('event', 'Atras2', {'event_category': 'Atras2', 'event_label': 'Atras2', 'value': 'Atras2'});
    this.location.back();
  }

  esAntigua(texto) {
    return texto.match(/^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}$/i);
  }

  esNueva(texto) {
    return texto.match(/^[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i);
  }

  isMotoOld(texto) {
    // Validate format XX0111 / XX111 / XXX011 / XXX11
    return texto.match(/^[a-z]{2}0[0-9]{3}$|^[a-z]{2}[0-9]{3}$/i);
  }

  isMotoNew(texto) {
    // Validate format XX0111 / XX111 / XXX011 / XXX11
    return texto.match(/^[b-d,f-h,j-l,p,r-t,v-z]{3}[0-9]{2}$|^[b-d,f-h,j-l,p,r-t,v-z]{3}0[0-9]{2}$/i);
  }

  isCarroArrastre(texto) {
    // Validate format XX0111 / XX111 / XXX011 / XXX11
    return texto.match(/^[a-zA-Z]{3}[1-9]{1}[0-9]{2}$/i);
  }

  getInfoRecaptcha() {
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token) => {
        console.log(`Token [${token}] generated`)
          const auxiliar = this._recaptchaService.getTokenClientModule(token)
          auxiliar.subscribe( {
            complete: () => {

            },
            error: () => {
              this.myProcesoRecaptcha = true;
            },
            next: (resultado: Boolean) => {
              if (resultado === true) {
                this.onSubmit();
                this.myRecaptcha = false;
              } else {
                this.myRecaptcha = true;
              }
            }
          });
        }
      );
  }

  atras(){
    gtag('event', 'Cancelar1', {'event_category': 'Cancelar1', 'event_label': 'Cancelar1', 'value': 'Cancelar1'});
    this.route.navigate(['/booking/search-type']);
  }
}
